module.exports = __webpack_public_path__ + "img/135ne.b2b61859.svg";